import {ElMessage} from "element-plus";
import axios from "axios";
import router from "@/router";
import {useStore, mapState} from "vuex"

import store from "@/store";
import sha256 from 'sha256'

// axios.defaults.baseURL = 'http://localhost:8199/'
// axios.defaults.baseURL = 'http://193.112.190.174:8197/WebServer/'
// axios.defaults.baseURL = 'http://139.9.181.241/WebServer2/'
axios.defaults.baseURL = 'http://120.78.92.171:8080/WebServer/official-EN/'

export const mixins = {
	data() {
		return {}
	},
	methods: {
		errorStatus(res, error) {
			ElMessage({
				message: res.data.msg,
				type: 'error',
				grouping: true,
			})
			if (res.data.data != null) {
				if (res.data.data.code == -1) {
					router.replace('/Login').then(r => {
					})
				}
			}
			if (error != null) {
				error(res)
			}
		},
		CheckToken(url, token) {
			if (token == null) {
				ElMessage({
					message: '登录失效',
					type: 'warning',
					grouping: true,
				})
				setTimeout(function () {
					router.replace('/Login').then(r => {
					})
				}, 100)
				return false
			}
			return true
		},
		axiosPost(url, data, sunccess, error) {
			// if (!this.CheckToken(url, sessionStorage.token)) return false;
			// let URL = (store.state.zhongying == 'true' || store.state.zhongying == true) ? 'official' + url : 'official-EN' + url
			axios.post(url, data).then((res) => {
				// console.log(res)
				if (!res.data.status) {
					console.log(res)
					this.errorStatus(res, error)
				} else {
					if (sunccess != null) {
						sunccess(res)
					}
				}
			}).catch((res) => {
				console.log('url---' + url)
				console.log(res)
				ElMessage.error('连接服务器失败')
			})
		},
		getNonce() {
			let chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
			let randomNum = "";
			for (let i = 0; i < 32; i++) {
				let id = parseInt(Math.random() * 61);
				randomNum += chars[id];
			}
			return randomNum;
		},
		axiosPost2(url, data, sunccess, error) {
			axios.post(url, data).then((res) => {
				console.log('url---' + url)
				console.log(res.data)
				if (!res.data.status) {
					this.errorStatus(res, error)
				} else {
					if (sunccess != null) {
						sunccess(res)
					}
				}
			}).catch((res) => {
				console.log('url---' + url)
				console.log(res)
				ElMessage.error('连接服务器失败')
			})
		},
		axiosFrom(url, data, sunccess, error) {
			let timestamp = Date.now()
			let nonce = this.getNonce()
			let signature = sha256(sessionStorage.token + nonce + timestamp)
			let urls = url + '?signature=' + signature + '&timestamp=' + timestamp + '&nonce=' + nonce + '&user_id=' + sessionStorage.user_id
			axios.post(urls, data, {headers: {'Content-Type': 'multipart/form-data'}}).then((res) => {
				console.log(url)
				console.log(res.data)
				if (!res.data.status) {
					this.errorStatus(res, error)
				} else {
					if (sunccess != null) {
						sunccess(res)
					}
				}
			}).catch((res) => {
				console.log('url---' + url)
				console.log(res)
				ElMessage.error('连接服务器失败')
			})
		},
		setRouter(url) {
			const hash = window.location.hash
			const h = hash.slice(7)
			if (url != h) {
				router.replace('/Index' + url).then(r => {
				})
				return false
			}
			return true
		},
		copy(value, cb) {
			// 动态创建 textarea 标签
			const textarea = document.createElement('textarea')
			// 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
			textarea.readOnly = 'readonly'
			textarea.style.position = 'absolute'
			textarea.style.left = '-9999px'
			// 将要 copy 的值赋给 textarea 标签的 value 属性
			// 网上有些例子是赋值给innerText,这样也会赋值成功，但是识别不了\r\n的换行符，赋值给value属性就可以
			textarea.value = value
			// 将 textarea 插入到 body 中
			document.body.appendChild(textarea)
			// 选中值并复制
			textarea.select()
			textarea.setSelectionRange(0, textarea.value.length)
			document.execCommand('Copy')
			document.body.removeChild(textarea)
			if (cb && Object.prototype.toString.call(cb) === '[object Function]') {
				cb()
			}

		},

	}
}
